export const isDocumentMime = (mime: string) =>
  [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.text',
    'application/x-iwork-pages-sffpages',
  ].includes(mime)

export const isSpreadsheetMime = (mime: string) =>
  [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroenabled.12',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.apple.numbers',
    'application/x-iwork-numbers-sffnumbers',
    'text/csv',
  ].includes(mime)

export const isPresentationMime = (mime: string) =>
  [
    'application/vnd.ms-powerpoint',
    'application/vnd.apple.keynote',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/x-iwork-keynote-sffkey',
    'application/vnd.oasis.opendocument.presentation',
  ].includes(mime)

export const isVideoMime = (mime: string) =>
  mime.startsWith('video/') || ['application/x-shockwave-flash'].includes(mime)

export const isImageMime = (mime: string) => mime.startsWith('image')

export const isVectorMime = (mime: string) =>
  ['image/svg+xml', 'application/postscript', 'application/vnd.adobe.illustrator'].includes(mime)

export const isAudioMime = (mime: string) =>
  mime.startsWith('audio/') ||
  [
    'application/vnd.apple.mpegurl',
    'audio/x-mpegurl',
    'application/pls+xml',
    'application/vnd.ms-wpl',
    'application/cda+xml',
    'video/x-ms-wma',
  ].includes(mime)

export const isJsonMime = (mime: string) => ['application/json', 'application/ld+json'].includes(mime)

export const isCodeMime = (mime: string) => ['text/html'].includes(mime)

export const isEmailMessageMime = (mime: string) =>
  [
    'message/rfc822',
    'application/vnd.ms-outlook',
    'text/x-vcard',
    'text/vcard',
    'text/directory',
    'text/x-vcalendar',
  ].includes(mime)

export const isPdfMime = (mime: string) => ['application/pdf', 'application/x-pdf'].includes(mime)

export const isTextMime = (mime: string) => ['text/plain', 'text/rtf'].includes(mime)

export const isArchiveMime = (mime: string) =>
  [
    'application/zip',
    'application/x-compress',
    'application/x-compressed',
    'application/x-rar',
    'application/x-rar-compressed',
    'application/x-tar',
    'application/x-gtar',
    'application/x-tgz',
    'application/gzip',
    'application/x-gzip',
    'application/x-7z-compressed',
  ].includes(mime)

export const isContactMime = (mime: string) => ['text/x-vcard', 'text/vcard'].includes(mime)
